<template>
    <v-container max-width="100%" style="margin-top: 2%">

        <v-container class="toolbar__container">
            <v-form ref="form" v-model="formValidado">
                <v-row>
                    <v-col cols="12" sm="6" md="2">
                        <v-select :items="empresas" v-model="empresaSelecionada" item-text="razao_social"
                            item-value="id_empresa" :label="$t('routs.headers.company')" clearable />
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <MultiplaEscolha
                            ref="veiculosSelect"
                            lazy
                            get-url="getVeiculoslazy"
                            v-bind:selected-items.sync="veiculosSelecionados"
                            :all-matching-selected.sync="veiculosAllMatching"
                            text="cod_veiculo"
                            value="id_veiculo"
                            :label="$t('nav.registration.vehicles')"
                            :max-items="2"
                            :can-toggle-all="true"
                        />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <MultiplaEscolha
                            ref="linhasSelect"
                            lazy
                            get-url="getLinhaslazy"
                            v-bind:selected-items.sync="linhasSelecionadas"
                            :all-matching-selected.sync="linhasAllMatching"
                            text="nome_linha"
                            value="id_linha"
                            :label="$t('nav.registration.lines')"
                            :max-items="2"
                            :can-toggle-all="true"
                        />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <MultiplaEscolha
                            ref="cercasSelect"
                            lazy
                            get-url="getCercaslazy"
                            v-bind:selected-items.sync="cercasSelecionadas"
                            :all-matching-selected.sync="cercasAllMatching"
                            text="nome_cerca"
                            value="id_cerca"
                            :label="$tc('geofence.self', 1)"
                            :max-items="1"
                            :can-toggle-all="true"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="4" md="4">
                        <v-datetime-picker :label="$tc('delayByGeofence.startDate', 1)" v-model="dti"
                            :time-picker-props="timeProps" :date-picker-props="dtiProps"
                            :text-field-props="textFieldProps" time-format="HH:mm:ss" date-format="dd/MM/yyyy"
                            :clear-text="$t('button.close')">
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-datetime-picker :label="$tc('delayByGeofence.endDate', 1)" v-model="dtf"
                            :time-picker-props="timeProps" :date-picker-props="dtfProps"
                            :text-field-props="textFieldProps" time-format="HH:mm:ss" date-format="dd/MM/yyyy"
                            :clear-text="$t('button.close')">
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <MultiplaEscolha
                            ref="unidadesSelect"
                            lazy
                            get-url="getUnidadeslazy"
                            :items="semUnidadeOption"
                            v-bind:selected-items.sync="unidadesSelecionadas"
                            :all-matching-selected.sync="unidadesAllMatching"
                            text="descricao_unidade"
                            value="id_unidade"
                            :label="$t('nav.registration.units')"
                            :max-items="2"
                            :can-toggle-all="true"
                        />
                    </v-col>
                    <v-col cols="12" sm="1" md="1" align="end">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                                    @click="populaRelatorio" style="margin-bottom: 5px;">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.search') }}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>

        <MerusDataTable :headers="headers" :items="atrasosFiltered" :loading="loading" :default-multi-sort="defaultSort"
            :loading-text="$t('delayByGeofence.loading')"

 cod-tabela="RELATRASOCERCAS" @update:headers="headers = $event">
            <template v-slot:toolbar>
                <CadastroToolbar :title="$t('delayByGeofence.title')" :token="token" :items="atrasosFiltered"
                    csv-title="atrasosocupacaocercas" :pdf-title="$t('delayByGeofence.title')" :pdf-headers="headers"
                    pdf-filename="atrasosocupacaocercas" hide-search>
                </CadastroToolbar>
            </template>
            <template v-slot:item.taxa_ocupacao="{ item }">
                {{ item.taxa_ocupacao != null ? `${item.taxa_ocupacao}%` : null }}
            </template>
        </MerusDataTable>
    </v-container>

</template>
<script>

import MultiplaEscolha from './Selects/MultiplaEscolha.vue';
import apiController from '@/utils/apiController';
import DateUtils from '../utils/dateutils';
import MerusDataTable from "../components/Tables/MerusDataTable.vue"
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';

export default {
    components: {
        MultiplaEscolha,
        MerusDataTable,
        CadastroToolbar
    },
    data: () => ({
    headers: [],
        user: null,
        token: null,
        config: null,
        formValidado: false,
        empresas: [],
        empresaSelecionada: null,
        veiculosSelecionados: [],
        linhasSelecionadas: [],
        cercasSelecionadas: [],
        unidadesSelecionadas: [],
        veiculosAllMatching: true,
        linhasAllMatching: true,
        cercasAllMatching: true,
        unidadesAllMatching: true,
        filtrosResolvidos: {
            veiculos: null,
            linhas: null,
            cercas: null,
            unidades: null,
        },
        dti: null,
        dtf: null,
        timeProps: {
            useSeconds: true,
        },
        search: "",
        atrasos: [],
        loading: false,
    }),
    computed: {
        semUnidadeOption() {
            return [
                {
                    id_unidade: -1,
                    descricao_unidade: 'Sem Unidade',
                    cod_unidade: 'SU',
                },
            ];
        },
        defaultSort() {
            return [
                { value: 'dt_posicao', options: { text: this.$t('routs.increasing'), value: 1 } }];
        },
        textFieldProps() {
            return {
                prependInnerIcon: "mdi-calendar",
                rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
            }
        },
        today() {
            return new Date().toISOString().substring(0, 10);
        },
        dtiProps() {
            return {
                max: this.today,
            }
        },
        dtfProps() {
            let min = null;
            if (this.dti) {
                if (typeof this.dti === 'string') {
                    min = `${this.dti.substring(6, 10)}-${this.dti.substring(3, 5)}-${this.dti.substring(0, 2)}`;
                } else {
                    min = this.dti.toISOString().substring(0, 10);
                }
            }
            return {
                min: min,
            }
        },
        atrasosFiltered() {
            let dados = this.atrasos;
            if (this.empresaSelecionada) {
                dados = dados.filter((d) => d.id_empresa == this.empresaSelecionada);
            } else if (this.user && this.user.id_cliente != null && this.user.id_cliente !== '') {
                dados = dados.filter((d) => d.id_cliente == this.user.id_cliente);
            }
            const linhas = this.filtrosResolvidos.linhas;
            if (Array.isArray(linhas) && linhas.length > 0) {
                dados = dados.filter((d) => linhas.includes(d.id_linha));
            }

            const veiculos = this.filtrosResolvidos.veiculos;
            if (Array.isArray(veiculos) && veiculos.length > 0) {
                dados = dados.filter((d) => veiculos.includes(d.id_veiculo));
            }

            const cercas = this.filtrosResolvidos.cercas;
            if (Array.isArray(cercas) && cercas.length > 0) {
                dados = dados.filter((d) => cercas.includes(d.id_cerca));
            }

            const unidades = this.filtrosResolvidos.unidades;
            if (Array.isArray(unidades) && unidades.length > 0) {
                const selecionadas = unidades.map((id) => Number(id));
                dados = dados.filter((d) => {
                    const unidadesRow = Array.isArray(d.unidades) && d.unidades.length > 0
                        ? d.unidades.map((id) => Number(id))
                        : (d.id_unidade != null && d.id_unidade !== '' ? [Number(d.id_unidade)] : []);
                    return unidadesRow.some((u) => selecionadas.includes(u));
                });
            }
            return dados;
        }
    },
    watch: {
        '$i18n.locale'() {
            this.initialize();
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        },
        veiculosSelecionados() { this.onSelecaoAlterada(); },
        linhasSelecionadas() { this.onSelecaoAlterada(); },
        cercasSelecionadas() { this.onSelecaoAlterada(); },
        unidadesSelecionadas() { this.onSelecaoAlterada(); },
        veiculosAllMatching() { this.onSelecaoAlterada(); },
        linhasAllMatching() { this.onSelecaoAlterada(); },
        cercasAllMatching() { this.onSelecaoAlterada(); },
        unidadesAllMatching() { this.onSelecaoAlterada(); },
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.initialize();
    },
    mounted() {
        this.$nextTick(() => {
            this.inicializarSelecoesPadrao();
        });
    },
    methods: {

        initialize() {
            this.getConfig();
            this.populaEmpresas();
            this.$nextTick(() => {
                this.inicializarSelecoesPadrao();
            });
        },
        inicializarSelecoesPadrao() {
            this.veiculosAllMatching = true;
            this.linhasAllMatching = true;
            this.cercasAllMatching = true;
            this.unidadesAllMatching = true;
            ['veiculosSelect', 'linhasSelect', 'cercasSelect', 'unidadesSelect'].forEach((refName) => {
                const ref = this.$refs[refName];
                if (ref && typeof ref.setAllMatching === 'function') {
                    ref.setAllMatching(true);
                }
            });
        },
        async onSelecaoAlterada() {
            if (!this.atrasos.length) {
                return;
            }
            await this.atualizarFiltrosResolvidos();
        },
        async atualizarFiltrosResolvidos() {
            const specs = [
                {
                    ref: 'veiculosSelect',
                    key: 'veiculos',
                    allMatching: this.veiculosAllMatching,
                    selected: this.veiculosSelecionados,
                },
                {
                    ref: 'linhasSelect',
                    key: 'linhas',
                    allMatching: this.linhasAllMatching,
                    selected: this.linhasSelecionadas,
                },
                {
                    ref: 'cercasSelect',
                    key: 'cercas',
                    allMatching: this.cercasAllMatching,
                    selected: this.cercasSelecionadas,
                },
                {
                    ref: 'unidadesSelect',
                    key: 'unidades',
                    allMatching: this.unidadesAllMatching,
                    selected: this.unidadesSelecionadas,
                },
            ];

            for (const spec of specs) {
                const selectRef = this.$refs[spec.ref];
                if (spec.allMatching && selectRef && typeof selectRef.resolveSelection === 'function') {
                    this.filtrosResolvidos[spec.key] = await selectRef.resolveSelection();
                } else if (Array.isArray(spec.selected) && spec.selected.length > 0) {
                    this.filtrosResolvidos[spec.key] = [...spec.selected];
                } else {
                    this.filtrosResolvidos[spec.key] = null;
                }
            }
        },
        getConfig() {
            apiController.request(apiController.endpoints.getallConfig, {
                onSuccess: (response) => {
                    this.config = response.data[0];
                    [this.dti, this.dtf] = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);
                },
                onError: (e) => {
                    this.erro = {
                        type: "Axios",
                        message: e.message,
                        status: e.response.status
                    };
                }
            });
        },
        populaEmpresas() {
            apiController.request(apiController.endpoints.getallEmpresas, {
                onSuccess: (response) => {
                    this.empresas = response.data;
                },
                onError: (e) => {
                    this.erro = {
                        type: "Axios",
                        message: e.message,
                        status: e.response.status
                    };
                }
            });
        },
        async populaRelatorio() {
            this.loading = true;
            try {
                await this.atualizarFiltrosResolvidos();
            } catch (_err) {
                this.loading = false;
                return;
            }

            let dti = DateUtils.getDateSQLFormatted(this.dti);
            let dtf = DateUtils.getDateSQLFormatted(this.dtf);

            apiController.request(apiController.endpoints.getAtrasocercasdata, {
                params: { dti: dti, dtf: dtf },
                onSuccess: (response) => {
                    this.atrasos = response.data;
                    this.loading = false;
                },
                onError: (e) => {
                    this.loading = false;
                    this.erro = {
                        type: "Axios",
                        message: e.message,
                        status: e.response.status
                    };
                }
            });
        }
    }
}
</script>
<style lang="">

</style>
